import styled from 'styled-components'

export const Separator = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.border.A};
  margin-bottom: 24px;
`
